<template>
    <div class="indexContent">
        <div class="indexTop">
            <div class="itSpb spb">
                <div class="indexNavContnet">
                    <div class="indexNavItem" v-for="(item,index) in indexData.nav" :key="index">
                        <div class="indexNavBox">
                            <div class="indexNavTitle">{{ item.name }}</div>
                            <div class="indexNavList" v-if="item.list && item.list.length > 0">
                                <div class="indexNav" @click="categoryTap(item.list[0].url)">{{ item.list[0].name }}</div>
                            </div>
                            <div class="navItemBox">
                                <div class="navItemTitle">{{ item.name }}</div>
                                <div class="flex">
                                    <div class="navItem" v-for="(el,i) in item.list" :key="i" @click="categoryTap(el.url)">{{ el.name }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="indexBanner">
                    <transition-group name="fadeIn">
                        <div class="slide" v-for="(item,index) in indexData.banner" v-if="index === curpage" :key="index">
                            <a :href="item.url" target="_blank">
                                <img :src="item.img" alt="" class="banner">
                            </a>
                        </div>
                    </transition-group>
                    <div class="indicateBox center">
                        <div :class="['indicate',index === curpage ? 'indicateOn' : '']" v-for="(item,index) in indexData.banner" :key="index" @click="indicateTap(index)"></div>
                    </div>
                    <!-- <el-carousel height="422px">
                        <el-carousel-item v-for="(el,index) in indexData.banner" :key="index">
                            <el-image :src="el.img" fit="cover" class="banner" @click="categoryTap(el.url)"></el-image>
                        </el-carousel-item>
                    </el-carousel> -->
                </div>
                <div class="indexNavContnet" style="padding: 16px 24px;width: 248px;">
                    <div class="indexWelcome">欢迎来到{{ indexData.name }}</div>
                    <div class="loginTips">{{ userDetail == 0 ? '登录后可享受更多权益' : '登录成功' }} </div>
                    <div class="indexBtnBox spb">
                        <div class="indexBtn loginBtn" @click="getLogin" v-if="userDetail == 0">立即登录</div>
                        <div class="indexBtn loginBtn" v-else>我的订单</div>
                        <!--  @click="getMy" -->
                        <div class="indexBtn settleBtn" @click="settleBtnTap">入驻服务商</div>
                    </div>
                    <div class="announcement">
                        <div class="announcementTop spb" @click="getNotice">
                            <div class="announcementTitle">公告</div>
                            <img src="../assets/icon/more.png" class="anMoreIcon">
                        </div>
                        <div class="announcementItem" v-for="(item,index) in indexData.notice" :key="index" @click="noticeTap(item.id)">{{ item.title }}</div>
                    </div>
                </div>
            </div>
            <!-- 数据统计 -->
            <!-- <div class="statisticsList spb">
                <div class="statistics center">
                    <div>
                        <div class="staTitle">我要提需求</div>
                        <div class="staNav">去发布&nbsp;&nbsp;></div>
                    </div>
                    <el-image :src="require('@/assets/icon/statistics01.png')" fit="cover" class="statisticsIcon"></el-image>
                </div>
                <div class="statistics center">
                    <div>
                        <div class="staTitle">服务商入驻</div>
                        <div class="staNav">去入驻&nbsp;&nbsp;></div>
                    </div>
                    <el-image :src="require('@/assets/icon/statistics02.png')" fit="cover" class="statisticsIcon"></el-image>
                </div>
                <div class="statistics center">
                    <div>
                        <div class="staTitle">帮助中心</div>
                        <div class="staNav">去看看&nbsp;&nbsp;></div>
                    </div>
                    <el-image :src="require('@/assets/icon/statistics03.png')" fit="cover" class="statisticsIcon"></el-image>
                </div>
            </div> -->
        </div>
        <!-- 爆品推荐&新品上线 -->
        <div class="productContent spb">
            <div class="productBox">
                <img src="../assets/icon/productTitle01.png" class="productTitle">
                <div class="productList spb">
                    <div class="product column" v-for="(item,index) in indexData.baokuan" :key="index" @click="categoryTap(item.url)">
                        <el-image :src="item.img" fit="cover" class="productImg"></el-image>
                        <div class="productName">{{ item.name }}</div>
                        <div class="productTipsList flex">
                            <div class="productTips" v-for="(el,ii) in item.biaoqian" :key="ii">{{ el }}</div>
                        </div>
                        <div class="price"><span class="priceIcon">￥</span>{{ item.price }}</div>
                    </div>
                </div>
            </div>
            <div class="productBox">
                <img src="../assets/icon/productTitle02.png" class="productTitle">
                <div class="productList spb">
                    <div class="product column" v-for="(item,index) in indexData.xinpin" :key="index" @click="categoryTap(item.url)">
                        <el-image :src="item.img" fit="cover" class="productImg"></el-image>
                        <div class="productName">{{ item.name }}</div>
                        <div class="productTipsList flex">
                            <div class="productTips" v-for="(el,ii) in item.biaoqian" :key="ii">{{ el }}</div>
                        </div>
                        <div class="price"><span class="priceIcon">￥</span>{{ item.price }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 开发 -->
        <div class="indexModule">
            <div class="moduleTitle">开发</div>
            <div class="developList flex">
                <div class="developBox flex" v-for="(item,index) in indexData.kaifa" :key="index" @click="categoryTap(item.url)">
                    <el-image :src="item.img" fit="cover" class="developImg"></el-image>
                    <div class="develop">
                        <div class="title">{{ item.name }}</div>
                        <div class="tipsList flex">
                            <div class="tips" v-for="(el,ii) in item.biaoqian" :key="ii">{{ el }}</div>
                        </div>
                        <div class="price"><span class="priceIcon">￥</span>{{ item.price }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 服务 -->
        <div class="indexModule">
            <div class="moduleTitle">服务</div>
            <div class="developList flex">
                <div class="serviceBox flex" v-for="(item,index) in indexData.fuwu" :key="index" @click="categoryTap(item.url)">
                    <el-image :src="item.img" fit="cover" class="serviceImg"></el-image>
                    <div class="service">
                        <div class="title">{{ item.name }}</div>
                        <div class="text"></div>
                        <div class="price"><span class="priceIcon">￥</span>{{ item.price }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 右侧悬浮 -->
        <div class="contactList">
            <div class="contactpos">
                <el-image :src="require('@/assets/icon/contact01.png')" fit="cover" class="contactIcon"></el-image>
                <div class="contactName">联系客服</div>
                <div class="contactContent contactShow">
                    <div class="contactHi">Hi,联系专属客服</div>
                    <div class="contactTitle">为您寻找最适合的产品解决方案</div>
                    <div class="contactBox column">
                        <el-image :src="indexData.kefu" class="contactImg"></el-image>
                        <div class="contactTips">扫码添加客服微信</div>
                    </div>
                </div>
            </div>
            <div class="contactpos">
                <el-image :src="require('@/assets/icon/contact02.png')" fit="cover" class="contactIcon"></el-image>
                <div class="contactName">电话咨询</div>
                <div class="telBox contactShow">
                    <div style="display: flex;">
                        <el-image :src="require('@/assets/icon/contact03.png')" fit="cover" class="telIcon"></el-image>
                        <div>
                            <div class="telNum">{{ indexData.tel }}</div>
                            <div class="flex">
                                <div class="telName">{{ indexData.lianxiren }}</div>
                                <div class="workTime">（{{ indexData.gongzuotime }}）</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                userDetail: 0,
                loginShow: false,
                indexData: {},
                curpage: 0
            }
        },
        mounted(){
            this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
            this.getIndexData()
        },
        methods: {
            // banner动画
            setTimer(){
                this.timer=setInterval(()=>{
                    this.curpage++;
                    if(this.curpage==this.indexData.banner.length){
                        this.curpage=0
                    }
                },5000)
            },
            // banner切换点
            indicateTap(e){
                this.curpage = e
            },
            // 获取首页数据
            getIndexData(){
                this.request.get("index/index/center",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.indexData = res.data
                    document.title = res.data.title
                    this.setTimer();
                })
            },
            // 跳转登录
            getLogin(){
                this.$router.push({ path:'/login/login' })
            },
            // 自定义跳转
            categoryTap(e){
                this.$router.push({ path:e })
            },
            // 入驻服务商跳转
            settleBtnTap(){
                window.location.href = this.categoryData.ruzhu
            },
            // 跳转更多公告
            getNotice(){
                this.$router.push({ path:'/notice/notice' })
            },
            // 跳转公告详情
            noticeTap(e){
                this.$router.push({ path:'/notice/noticeDetail', query:{id: e} })
            }
        }
    }
</script>
<style lang="less" scoped>

    .indexContent{
        background: #F7F8FA;
        padding-bottom: 85px;
        .indexTop{
            width: 100vw;
            padding-top: 8px;
            .itSpb{
                width: 1232px;
                margin: 0 auto;
                .indexNavContnet{
                    width: 246px;
                    height: 390px;
                    padding: 16px 0;
                    background: #fff;
                    border-radius: 8px;
                    .indexNavItem{
                        padding: 0 16px;
                        position: relative;
                        &:hover{
                            .indexNavBox{
                                background: #0F59FE;
                            }
                            .indexNavTitle,.indexNav{
                                color: #fff !important;
                            }
                            .navItemBox{
                                display: block;
                            }
                        }
                        .indexNavBox{
                            width: 182px;
                            height: 54px;
                            padding: 16px;
                            border-radius: 8px;
                            margin-top: 15px;
                            cursor: pointer;
                            &:first-child{
                                margin: 0;
                            }
                            .indexNavTitle{
                                font: 16px/22px "Microsoft YaHei";
                                color: #161825;
                            }
                            .indexNavList{
                                padding-top: 12px;
                                display: flex;
                                flex-wrap: wrap;
                                .indexNav{
                                    width: 182px;
                                    font: 14px/18px "Microsoft YaHei";
                                    color: #73727A;
                                    padding: 0 12px;
                                    cursor: pointer;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    &:first-child{
                                        padding-left: 0;
                                    }
                                }
                            }
                        }
                        .navItemBox{
                            padding: 24px;
                            width: 384px;
                            border-radius: 8px;
                            background: #fff;
                            box-shadow: 0px 2px 22px 0px rgba(32, 25, 53, 0.05);
                            position: absolute;
                            left: 246px;
                            top: 0;
                            z-index: 99;
                            display: none;
                            .navItemTitle{
                                font: bold 14px/18px "Microsoft YaHei";
                                color: #161825;
                            }
                            .navItem{
                                width: 180px;
                                font: 14px/18px "Microsoft YaHei";
                                color: #73727A;
                                margin: 20px 20px 0 0;
                                &:nth-child(2n){
                                    margin-right: 0;
                                }
                                &:hover{
                                    color: #0F59FE;
                                }
                            }
                        }
                    }
                    .indexWelcome{
                        font: bold 22px/30px "Microsoft YaHei";
                        color: #47474F;
                        text-align: center;
                        margin-top: 30px;
                    }
                    .loginTips{
                        font: 16px/22px "Microsoft YaHei";
                        color: #ADACB1;
                        text-align: center;
                        margin-top: 40px;
                    }
                    .indexBtnBox{
                        margin-top: 19px;
                        padding: 0 15px;
                        .indexBtn{
                            width: 100px;
                            height: 30px;
                            border-radius: 4px;
                            font: 14px/30px "Microsoft YaHei";
                            text-align: center;
                            cursor: pointer;
                            border: 1px solid #0F59FE;
                            text-align: center;
                        }
                        .loginBtn{
                            background: #0F59FE;
                            color: #fff;
                        }
                        .settleBtn{
                            color: #0F59FE;
                        }
                    }
                    .announcement{
                        margin-top: 26px;
                        height: 190px;
                        .announcementTop{
                            padding: 14px 0;
                            border-top: 1px solid #F5F5F5;
                            cursor: pointer;
                            .announcementTitle{
                                font: 16px/20px "Microsoft YaHei";
                                color: #161825;
                            }
                            .anMoreIcon{
                                width: 6px;
                                height: 12px;
                            }
                        }
                        .announcementItem{
                            font: 14px/18px "Microsoft YaHei";
                            color: #575757;
                            padding: 7px 0;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            cursor: pointer;
                            &:hover{
                                color: #0F59FE;
                            }
                        }
                    }
                }
                .indexBanner{
                    width: 660px;
                    height: 422px;
                    border-radius: 8px;
                    overflow: hidden;
                    position: relative;
                    .slide{
                        width: 660px;
                        height: 422px;
                        position: absolute;
                        left: 0;
                        top: 0;
                        z-index: 1;
                        .banner{
                            width: 660px;
                            height: 422px;
                            cursor: pointer;
                        }
                    }
                    .fadeIn-enter-active,.fadeIn-leave-active {
                        transition: all 1s ease;
                    }
                    .fadeIn-enter-active,.fadeIn-leave{
                        opacity: 1;
                    }
                    .fadeIn-enter,.fadeIn-leave-active {
                        opacity: 0.1;
                    }
                    .indicateBox{
                        width: 660px;
                        height: 8px;
                        position: absolute;
                        left: 0;
                        bottom: 40px;
                        z-index: 2;
                        .indicate{
                            width: 8px;
                            height: 8px;
                            border-radius: 4px;
                            background: rgba(255,255,255,0.4);
                            margin-left: 5px;
                            cursor: pointer;
                            &:first-child{
                                margin: 0;
                            }
                        }
                        .indicateOn{
                            width: 39px !important;
                            background: #fff !important;
                        }
                    }
                }
            }
            .statisticsList{
                width: 1232px;
                margin: 0 auto;
                padding-top: 18px;
                .statistics{
                    width: 400px;
                    height: 134px;
                    background: #fff;
                    border-radius: 8px;
                    color: #161825;
                    cursor: pointer;
                    &:hover{
                        color: #0F59FE;
                    }
                    .staTitle{
                        font: bold 18px/24px "Microsoft YaHei";
                    }
                    .staNav{
                        font: 18px/24px simhei;
                        margin-top: 12px;
                    }
                    .statisticsIcon{
                        width: 80px;
                        height: 80px;
                        margin-left: 70px;
                    }
                }
            }
        }
       .productContent{
            width: 1232px;
            padding-top: 56px;
            margin: 0 auto;
            .productBox{
                width: 608px;
                .productTitle{
                    width: 118px;
                    height: 24px;
                }
                .productList{
                    width: 608px;
                    padding-top: 16px;
                    .product{
                        width: 160px;
                        height: 176px;
                        padding: 16px;
                        background: #fff;
                        border-radius: 8px;
                        border: 1px solid #F5F5F5;
                        cursor: pointer;
                        .productImg{
                            width: 58px;
                            height: 58px;
                            border-radius: 8px;
                        }
                        .productName{
                            width: 160px;
                            font: 16px/22px "Microsoft YaHei";
                            color: #161825;
                            margin-top: 16px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .productTipsList{
                            width: 160px;
                            height: 28px;
                            margin: 16px 0;
                            .productTips{
                                padding: 0 8px;
                                height: 28px;
                                background: #F1F2FF;
                                border-radius: 4px;
                                font: 14px/28px "Microsoft YaHei";
                                color: #0F59FE;
                                margin-left: 10px;
                                &:first-child{
                                    margin: 0;
                                }
                            }
                        }
                        .price{
                            width: 160px;
                            font: bold 20px/22px "Microsoft YaHei";
                            color: #161825;
                            .priceIcon{
                                font: 16px/22px "Microsoft YaHei";
                            }
                        }
                    }
                }
            }
       }
       .indexModule{
            width: 1232px;
            padding-top: 24px;
            margin: 0 auto;
            .moduleTitle{
                font: 24px/56px "Microsoft YaHei";
                color: #161825;
            }
            .developList{
                width: 1232px;
                .developBox{
                    width: 365px;
                    height: 104px;
                    padding: 16px;
                    background: #fff;
                    border-radius: 8px;
                    border: 1px solid #F5F5F5;
                    margin: 16px 16px 0 0;
                    cursor: pointer;
                    &:nth-child(1){
                        margin-top: 0;
                    }
                    &:nth-child(2){
                        margin-top: 0;
                    }
                    &:nth-child(3){
                        margin-top: 0;
                    }
                    &:nth-child(3n){
                        margin-right: 0;
                    }
                    .developImg{
                        width: 58px;
                        height: 58px;
                        border-radius: 8px;
                    }
                    .develop{
                        padding-left: 12px;
                        .title{
                            width: 295px;
                            font: 16px/22px "Microsoft YaHei";
                            color: #161825;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .tipsList{
                            width: 295px;
                            height: 28px;
                            margin-top: 12px;
                            .tips{
                                padding: 0 8px;
                                height: 28px;
                                background: #F1F2FF;
                                border-radius: 4px;
                                font: 14px/28px "Microsoft YaHei";
                                color: #0F59FE;
                                margin-left: 10px;
                                &:first-child{
                                    margin: 0;
                                }
                            }
                        }
                        .price{
                            width: 295px;
                            font: bold 20px/22px "Microsoft YaHei";
                            color: #161825;
                            margin-top: 16px;
                            .priceIcon{
                                font: 16px/22px "Microsoft YaHei";
                            }
                        }
                    }
                }
                .serviceBox{
                    width: 365px;
                    height: 122px;
                    padding: 16px;
                    background: #fff;
                    border-radius: 8px;
                    border: 1px solid #F5F5F5;
                    margin: 16px 16px 0 0;
                    cursor: pointer;
                    &:nth-child(1){
                        margin-top: 0;
                    }
                    &:nth-child(2){
                        margin-top: 0;
                    }
                    &:nth-child(3){
                        margin-top: 0;
                    }
                    &:nth-child(3n){
                        margin-right: 0;
                    }
                    .serviceImg{
                        width: 200px;
                        height: 122px;
                        border-radius: 8px;
                    }
                    .service{
                        width: 153px;
                        padding-left: 12px;
                        .title{
                            width: 153px;
                            font: 16px/22px "Microsoft YaHei";
                            color: #161825;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .text{
                            width: 153px;
                            height: 54px;
                            font: 14px/18px "Microsoft YaHei";
                            color: #73727A;
                            -webkit-line-clamp: 3;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            margin-top: 14px;
                        }
                        .price{
                            width: 153px;
                            font: bold 20px/22px "Microsoft YaHei";
                            color: #161825;
                            margin-top: 10px;
                            .priceIcon{
                                font: bold 16px/22px "Microsoft YaHei";
                            }
                        }
                    }
                }
            }
       }
       .contactList{
            width: 72px;
            position: fixed;
            right: 20px;
            top: 40vh;
            z-index: 999;
            .contactpos{
                width: 72px;
                height: 72px;
                border-radius: 8px;
                background: #fff;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-bottom: 8px;
                cursor: pointer;
                position: relative;
                &:hover{
                    box-shadow: 0px 4px 44px 0px rgba(0,0,0,0.04);
                    .contactShow{
                        display: block;
                    }
                }
                .contactIcon{
                    width: 24px;
                    height: 24px;
                }
                .contactName{
                    font: 12px/16px "Microsoft YaHei";
                    color: #73727A;
                    margin-top: 6px;
                }
                .contactContent{
                    width: 230px;
                    border-radius: 8px;
                    background: #0F59FE;
                    position: absolute;
                    left: -236px;
                    bottom: 0;
                    box-shadow: 0px 4px 44px 0px rgba(0,0,0,0.04);
                    display: none;
                    .contactHi{
                        padding: 18px 0 0 18px;
                        font: bold 14px/18px "Microsoft YaHei";
                        color: #fff;
                    }
                    .contactTitle{
                        padding: 6px 0 0 18px;
                        font: 12px/14px "Microsoft YaHei";
                        color: #fff;
                    }
                    .contactBox{
                        width: 230px;
                        height: 202px;
                        // border-radius: 8px 8px 0 0;
                        background: #fff;
                        margin-top: 12px;
                        .contactImg{
                            width: 138px;
                            height: 138px;
                            border-radius: 12px;
                            margin-top: 21px;
                        }
                        .contactTips{
                            font: 12px/14px "Microsoft YaHei";
                            color: #73727A;
                            margin-top: 6px;
                        }
                    }
                }
                .telBox{
                    padding: 13px 24px;
                    background: #fff;
                    border-radius: 8px;
                    position: absolute;
                    right: 78px;
                    bottom: 0;
                    box-shadow: 0px 4px 44px 0px rgba(0,0,0,0.04);
                    display: none;
                    .telIcon{
                        width: 32px;
                        height: 32px;
                        margin-right: 8px;
                    }
                    .telNum{
                        font: 20px/32px "Microsoft YaHei";
                        color: #161825;
                    }
                    .telName{
                        font: 14px/18px "Microsoft YaHei";
                        color: #161825;
                        margin-top: 4px;
                    }
                    .workTime{
                        font: 12px/16px "Microsoft YaHei";
                        color: #73727A;
                        margin-top: 6px;
                    }
                }
            }
       }
    }
</style>